import React, { Component } from 'react';
import { default as ReactSelect, components } from 'react-select';

class Select extends Component {
  render() {
    const DropdownIndicator = props => {
      return (
        <components.DropdownIndicator {...props}>
          <div className="dropdown-toggle application-toggle" />
        </components.DropdownIndicator>
      );
    };

    const ClearIndicator = props => {
      const {
        children = '',
        getStyles,
        innerProps: { ref, ...restInnerProps }
      } = props;
      return (
        <div {...restInnerProps} ref={ref} style={getStyles('clearIndicator', props)}>
          <div>{children}</div>
        </div>
      );
    };

    const customStyles = {
      option: (provided, state) => ({
        ...provided
      }),
      control: () => ({
        // none of react-select's styles are passed to <Control />
        minWidth: 200,
        display: 'flex',
        borderBottom: '1px solid #b7b7b7',
        height: 30
      }),

      multiValue: base => ({ ...base, background: 'transparent' })
    };

    const { options, isMulti, value, placeholder } = this.props;
    return (
      <ReactSelect
        styles={customStyles}
        className="ml-3 select"
        value={value}
        components={{ ClearIndicator: ClearIndicator, DropdownIndicator: DropdownIndicator }}
        classNamePrefix="react-select"
        onChange={this.handleChange}
        options={options}
        placeholder={placeholder}
        isMulti={isMulti}
      />
    );
  }

  handleChange = options => {
    this.props.onChange(options);
  };
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/inputs/Select.js